import React from "react";

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import InputMask from "react-input-mask";
import SweetAlert2 from "react-sweetalert2";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faFlask, faDungeon } from "@fortawesome/free-solid-svg-icons";

import Util from "shared/services/Util";
import Header from "components/Headers/Header.js";
import { telMask } from "shared/services/Mask";
import Api from "shared/resources/Api";
import { sectors, neighborhood } from "shared/services/PlacesService";
import InputNumber from "react-input-just-numbers";
import swal from "sweetalert2";
export default class OvitrampList extends React.Component {
  /* Dados Grid */
  columns = [
    {
      name: "Cód Ovitrampa",
      maxWidth: "150px",
      minWidth: "100px",
      selector: "codigo",
      sortable: true,
    },
    {
      name: "Nome Proprietário",
      selector: "nome",
      sortable: true,
    },
    {
      name: "Armadilha (EDL)",
      sortable: true,
      cell: (row) => (
        <div>
          {row.armadilha_ligacoes !== undefined && row.armadilha_ligacoes.length > 0
            ? "Sim"
            : "Não"}
        </div>
      ),
    },
    {
      name: "Status",
      sortable: true,
      cell: (row) => (
        <div>
          {row.status !== undefined && row.status !== null
            ? Util.capitalize(row.status)
            : "Inativo"}
        </div>
      ),
    },
    {
      name: "Situação",
      sortable: true,
      cell: (row) => <div>{Util.capitalize(row.situacao)}</div>,
    },
    {
      name: "Telefone",
      sortable: true,
      cell: (row) => <div>{telMask(row.tel)}</div>,
    },
    {
      name: "Logradouro",
      sortable: true,
      selector: "logradouro",
    },
    {
      name: "Bairro",
      sortable: true,
      selector: "Bairro",
      cell: (row) => (
        <div>
          {row.bairro !== undefined && row.bairro !== null ? row.bairro : "-"}
        </div>
      ),
    },
    {
      name: "Setor",
      sortable: true,
      selector: "Setor",
      cell: (row) => (
        <div>
          {row.setor !== undefined && row.setor !== null ? row.setor : "-"}
        </div>
      ),
    },
    {
      name: "",
      center: true,
      cell: (row) => (
        <div style={{ display: "flex", flexWrap: "nowrap" }}>
          <Button
            type="button"
            className="btn-acao "
            title="Editar"
            onClick={() => {
              this.props.history.push("/admin/ovitramp-edit", {
                ovitramp: row,
              });
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="edit" />
          </Button>
            {localStorage.getItem("perm") !== "agente" &&
            row.status !== undefined &&
            row.status !== null &&
            row.status === "ativo" && (
              <Button
                type="button"
                className="btn-trap"
                title="Armadilhas (EDL)"
                onClick={() => {
                  this.openTrapModal(row);
                }}
              >
                <FontAwesomeIcon icon={faDungeon} rotation={180} className="edit" />
              </Button>
            )}
          {localStorage.getItem("perm") !== "agente" &&
            row.status !== undefined &&
            row.status !== null &&
            row.status === "ativo" && (
              <Button
                type="button"
                className="btn-lab"
                title="Movimentos"
                onClick={() => {
                  this.props.history.push("/admin/lab", {
                    ovitramp: row,
                    listSource: true,
                  });
                }}
              >
                <FontAwesomeIcon icon={faFlask} className="edit" />
              </Button>
            )}

          {localStorage.getItem("perm") !== "agente" && (
            <Button
              type="button"
              className="btn-acao "
              title="Remover"
              onClick={() => {
                this.handleDelete(row);
              }}
            >
              <FontAwesomeIcon icon={faTrashAlt} className="remove" />
            </Button>
          )}
        </div>
      ),
    },
  ];
  defaultComponentOptions = {
    rowsPerPageText: "Registros por Página:",
    rangeSeparatorText: "de",
    noRowsPerPage: false,
  };
  customStyles = {
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: 15,
        color: "#000",
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      response: "",
      nome: "",
      bairro: "",
      logradouro: "",
      tel: "",
      api: Api.baseURL,
      id: "",
      requesting: false,
      neighborhood: [],
      sectors: [],
      selectedSector: null,
      status: "ativo",
      selectedNeighborhood: null,
      situacao: "",
      codigo: null,
      showTrapModal: false,
      trapOptions: [],
      selectedTraps: [],
      trapSearch: "",
      selectedOvitramp: null,
    };
    this.trapDropdownRef = React.createRef();
  }
  componentWillMount() {
    document.addEventListener("keydown", (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        this.handleSubmit(event);
      }
    });

    if (localStorage.getItem("gridovi")) {
      var obj = JSON.parse(localStorage.getItem("gridovi"));
      this.setState({
        response: obj,
      });
    }

    neighborhood().then((res) => {
      if (res) {
        this.setState({
          neighborhood: res,
        });
      }
    });

    sectors().then((res) => {
      if (res) {
        this.setState({
          sectors: res,
        });
      }
    });
  }

  fetchSectors = async () => {
    const response = await fetch(Api.baseURL + "/setor", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        sectors: body,
      });
    }

    return body;
  };

  fetchNeighborhood = async () => {
    const response = await fetch(Api.baseURL + "/bairro", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        neighborhood: body,
      });
    }

    return body;
  };

  handleSubmit = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    this.setState({ response: "", requesting: true });

    this.fetchOvitramp()
      .then((res) =>
        this.setState({ response: res }, () => {
          localStorage.setItem("gridovi", JSON.stringify(res));
        })
      )
      .catch((err) => {
        console.log(err);
        this.setState({
          swal: {
            show: true,
            title: "Atenção",
            text: "Não foram encontradas ovitrampas para os parâmetros informados.",
            type: "error",
          },
          requesting: false,
        });
      });

  };
  
  fetchTraps = async () => {
    
    let host = this.state.api + "/imovel/cadastro?tipoorigem=armadilha";

    const response = await fetch(host, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    return body;
  };

  fetchOvitramp = async () => {
    let host = this.state.api + "/ovitrampa?";

    let params = {
      codigo:
        this.state.codigo !== null
          ? this.state.codigo.trim().toUpperCase()
          : "",
      situacao: this.state.situacao,
      nome: this.state.nome,
      status: this.state.status,
      logradouro: this.state.logradouro.trim(),
      tel: this.state.tel.replace(/\D/g, ""),
      bairro: this.state.bairro,
      setor:
        this.state.selectedSector !== null ? this.state.selectedSector : "",
    };
    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    const response = await fetch(host + query, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (body.length > 0) {
      this.setState({
        agent: body,
        requesting: false,
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Não foram encontradas ovitrampas para os parâmetros informados.",
          type: "error",
        },
        requesting: false,
      });
    }
    return body;
  };
  handleDelete = (element) => {
    this.setState({
      swal: {
        show: true,
        title: "Atenção",
        text: "Deseja realizar a exclusão deste registro?",
        type: "error",
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: "Cancelar",
      },
      ovitramp: element,
      isConfirmation: true,
    });
  };
  handleDeleteOvitramp(d) {
    this.callDel(d)
      .then()
      .catch((err) => console.log(err));
  }

  callDel = async (d) => {
    const response = await fetch(Api.baseURL + "/ovitrampa/" + d.id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        swal: {
          show: true,
          title: "Tudo Certo",
          text: "Ovitrampa deletada com sucesso!",
          type: "success",
        },
        response: "",
        nome: "",
        logradouro: "",
        tel: "",
        selectedNeighborhood: "",
        selectedSector: "",
        codigo: "",
        situacao: "",
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Erro ao deletar ovitrampa.",
          type: "error",
        },
      });

      throw Error(body.message);
    }

    return body;
  };

  fetchLinkedTraps = async (ovitrampId) => {
    const response = await fetch(Api.baseURL + "/ovitrampa/" + ovitrampId + "/armadilhas", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();
    return body;
  };


  openTrapModal = async (ovitramp) => {
    this.setState({
      showTrapModal: true,
      selectedOvitramp: ovitramp,
      trapSearch: "",
    });
   
    try {
      const traps = await this.fetchTraps();
      this.setState({
        trapOptions: Array.isArray(traps) ? traps : [],
        selectedTraps: [],
      });
      const linkedTraps = await this.fetchLinkedTraps(ovitramp.id);
      const linkedTrapIds = linkedTraps.armadilhas;
      console.log("Linked Trap IDs:", linkedTrapIds);
      this.setState({ selectedTraps: linkedTrapIds });  
    } catch (error) {
      console.error("Erro ao carregar armadilhas:", error);
      this.setState({ trapOptions: [], selectedTraps: [] });
    }
  };

  closeTrapModal = () => {
    this.setState({
      showTrapModal: false,
      selectedOvitramp: null,
      selectedTraps: [],
    });
  };
  
  linkArmadilhas = async () => {
    if (!this.state.selectedOvitramp) {
      swal.fire({
        title: "Erro",
        text: "Nenhuma ovitrampa selecionada para vincular.",
        icon: "error",
      });
      return false;
    }

    const ovitrampaId =
      this.state.selectedOvitramp.id || this.state.selectedOvitramp.oid_ovitrampa;
    const trapIds = this.state.selectedTraps.join(",") || 0;

    try {
      const response = await fetch(
        Api.baseURL + "/ovitrampa/" + ovitrampaId + "/armadilha/" + trapIds,
        {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("agToken"),
          },
        }
      );

      const body = await response.json();

      if (response.status !== 200) {
        throw new Error(body.message || "Erro ao vincular armadilhas (EDL)");
      }

      return body;
    } catch (error) {
      console.error("Erro ao vincular armadilhas (EDL):", error);
      swal.fire({
        title: "Erro",
        text: "Não foi possível vincular as armadilhas (EDL).",
        icon: "error",
      });
      return false;
    }
  };

  vincularArmadilhas = () => {
    swal.fire({
      title: "Confirmação",
      text: this.state.selectedTraps.length > 0
        ? `Deseja vincular as armadilhas (EDL) selecionadas a esta ovitrampa?`
        : "Deseja remover todas as armadilhas (EDL) desta ovitrampa?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.state.selectedTraps.length > 0 ? "Sim, vincular!" : "Sim, remover!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const linkResult = await this.linkArmadilhas();
        if (linkResult !== false) {

          swal.fire({
            title: "Tudo Certo",
            text: linkResult.armadilhas && linkResult.armadilhas.length > 0
              ? "Armadilhas (EDL) vinculadas com sucesso!"
              : "Armadilhas (EDL) removidas com sucesso!",
            icon: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.handleSubmit();
            }
          });
          this.setState({
            showTrapModal: false,
            selectedOvitramp: null,
            selectedTraps: [],
          });

        }
      }
    });
  };

  handleTrapCheckboxChange = (trapId) => {
    this.setState((prevState) => {
      const selectedTraps = prevState.selectedTraps.includes(trapId)
        ? prevState.selectedTraps.filter((id) => id !== trapId)
        : [...prevState.selectedTraps, trapId];
      return { selectedTraps };
    });
  };

  handleTrapSearchChange = (event) => {
    this.setState({ trapSearch: event.target.value });
  };

  getFilteredTraps = () => {
    const search = this.state.trapSearch.toLowerCase().trim();
    return this.state.trapOptions.filter((trap) => {
      const label = (trap.codigo || trap.nome || trap.ds_nome || "").toString().toLowerCase();
      return label.includes(search);
    });
  };

  render() {
    const filteredTraps = this.getFilteredTraps();
    const selectedTrapLabels = this.state.trapOptions
      .filter((trap) => this.state.selectedTraps.includes(trap.id || trap.oid_imovel || trap.codigo))
      .map((trap) => trap.codigo || trap.nome || trap.ds_nome || `Trap ${trap.id || trap.oid_imovel || trap.codigo}`)
      .join(", ");

    return (
      <>
        <SweetAlert2
          {...this.state.swal}
          onConfirm={(result) => {
            this.setState({
              swal: {
                show: false,
              },
            });

            if (this.state.isConfirmation && !result.dismiss) {
              this.setState({
                isConfirmation: false,
              });
              this.handleDeleteOvitramp(this.state.ovitramp);
            }
          }}
        />

        <Header />
        {/* Page content */}
        <Container className="mb-7 mt-5 " fluid>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Gerenciar Ovitrampas
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Ovitrampa
                            </label>

                            <Input
                              onlydigits
                              className="form-control"
                              id="input-id"
                              type="text"
                              // onInput={(e) => {
                              //   e.target.value = Math.max(
                              //     0,
                              //     parseInt(e.target.value)
                              //   )
                              //     .toString()
                              //     .slice(0, 6);
                              // }}
                              placeholder=""
                              value={this.state.codigo}
                              onChange={(e) =>
                                this.setState({ codigo: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            {this.state.sectors.length > 0 && (
                              <div>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-dtnascimento"
                                >
                                  Situação
                                </label>

                                <select
                                  value={this.state.situacao}
                                  onChange={(e) =>
                                    this.setState({
                                      situacao: e.target.value,
                                    })
                                  }
                                  className="form-control "
                                >
                                  <option defaultValue="" value="">
                                    {" "}
                                    Selecione...{" "}
                                  </option>
                                  <option value="amarelo">Amarelo</option>
                                  <option value="verde">Verde</option>
                                  <option value="vermelho">Vermelho</option>
                                </select>
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Nome Proprietário
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-nome"
                              type="text"
                              required
                              value={this.state.nome}
                              onChange={(e) =>
                                this.setState({ nome: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-tel"
                            >
                              Telefone
                            </label>
                            <InputMask
                              mask="(99) 99999-9999"
                              type="text"
                              inputMode="numeric"
                              name="tel"
                              id="tel"
                              className="form-control"
                              value={this.state.tel}
                              onChange={(e) =>
                                this.setState({ tel: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="2">
                          <FormGroup>
                            <div>
                              <label
                                className="form-control-label"
                                htmlFor="input-last-dtnascimento"
                              >
                                Status
                              </label>

                              <select
                                value={this.state.status}
                                onChange={(e) =>
                                  this.setState({ status: e.target.value })
                                }
                                className="form-control "
                              >
                                <option defaultValue="ativo" value="ativo">
                                  {" "}
                                  Ativo{" "}
                                </option>
                                <option value="inativo">Inativo</option>
                              </select>
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            {this.state.sectors.length > 0 && (
                              <div>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-dtnascimento"
                                >
                                  Setor
                                </label>

                                <select
                                  value={this.state.selectedSector}
                                  onChange={(e) =>
                                    this.setState({
                                      selectedSector: e.target.value,
                                    })
                                  }
                                  className="form-control "
                                >
                                  <option defaultValue="" value="">
                                    {" "}
                                    Selecione...{" "}
                                  </option>
                                  {this.state.sectors.map((team) => (
                                    <option
                                      key={team.id}
                                      value={team.nome}
                                      defaultValue={this.state.selectedSector}
                                    >
                                      {team.nome}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-bairro"
                            >
                              Bairro
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              maxLength="30"
                              value={this.state.bairro}
                              onChange={(e) =>
                                this.setState({ bairro: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-logradouro"
                            >
                              Logradouro
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-logradouro"
                              type="text"
                              required
                              value={this.state.logradouro}
                              onChange={(e) =>
                                this.setState({ logradouro: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>{" "}
                      </Row>
                    </div>
                    <div className="text-center">
                      <Row>
                        <Col className="order-xl-1" xl="12">
                          {" "}
                          <Button
                            className="mt-4 btn-zoo-alt"
                            color="primary"
                            type="button"
                            onClick={this.handleSubmit}
                          >
                            <b>Pesquisar</b>
                          </Button>
                          {localStorage.getItem("perm") !== "agente" && (
                            <Button
                              className="mt-4 btn-zoo"
                              color="primary"
                              type="button"
                              onClick={() => {
                                this.props.history.push("/admin/ovitramp-edit");
                              }}
                            >
                              <b>Cadastrar</b>
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.response && !this.state.requesting && (
            <DataTable
              noHeader={true}
              pagination={true}
              striped={true}
              columns={this.columns}
              responsive={true}
              highlightOnHover={true}
              data={this.state.response}
              paginationComponentOptions={this.defaultComponentOptions}
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
              customStyles={this.customStyles}
              progressPending={this.state.response === undefined}
              noDataComponent="Nenhum registro encontrado."
              paginationResetDefaultPage={this.state.response.length > 0}
            />
          )}
          {this.state.requesting && (
            <div className="text-center">
              <Spinner
                style={{ width: "3rem", height: "3rem" }}
                color="primary"
              />
            </div>
          )}
        </Container>
        <Modal
          isOpen={this.state.showTrapModal}
          toggle={this.closeTrapModal}
          className="custom-modal"
        >
          <ModalHeader
            toggle={this.closeTrapModal}
            className="custom-modal-header"
          >
            Armadilhas (EDL)
          </ModalHeader>
          <ModalBody>
            <p>
              {this.state.selectedOvitramp
                ? `Ovitrampa: ${this.state.selectedOvitramp.codigo} - ${this.state.selectedOvitramp.nome}`
                : "Nenhuma ovitrampa selecionada."}
            </p>
            <FormGroup>
              <label>
                {`Armadilhas (EDL) selecionadas: ${selectedTrapLabels || "Nenhuma armadilha selecionada"}`}
              </label>
              <Row>
                <Col lg="12">
                  <div ref={this.trapDropdownRef}>
                    
                      <div className="card mt-2 p-2" style={{ maxHeight: 240, overflowY: "auto" }}>
                        <div className="form-group mb-2">
                          <Input
                            type="text"
                            value={this.state.trapSearch}
                            onChange={this.handleTrapSearchChange}
                            placeholder="Digite para filtrar armadilha (EDL) ..."
                          />
                        </div>
                        {this.state.trapOptions && this.state.trapOptions.length > 0 ? (
                          <>
                            {filteredTraps
                              .map((trap) => {
                                const trapId = trap.id || trap.oid_imovel || trap.codigo;
                                const trapLabel = trap.codigo || trap.nome || trap.ds_nome || `Trap ${trapId}`;
                                return (
                                  <div key={trapId} className="form-check mb-1">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`trap-filter-${trapId}`}
                                      value={trapId}
                                      onChange={() => this.handleTrapCheckboxChange(trapId)}
                                      checked={this.state.selectedTraps.includes(trapId)}
                                    />
                                    <label
                                      className="form-check-label ml-2"
                                      htmlFor={`trap-filter-${trapId}`}
                                    >
                                      {trapLabel}
                                    </label>
                                  </div>
                                );
                              })}
                          </>
                        ) : (
                          <div>Nenhuma armadilha (EDL) disponível</div>
                        )}
                      </div>
                    
                  </div>
                </Col>
              </Row>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            
            <Button color="primary" onClick={this.vincularArmadilhas}>
              Vincular Armadilhas (EDL)
            </Button>
            <Button color="secondary" onClick={this.closeTrapModal}>
              Fechar
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
